// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__jVt7O","box":"style_box__8MLm1","active":"style_active__qVCj-","title":"style_title__5fJIZ","item":"style_item__LB3VE"};